module.exports = __webpack_public_path__ + "static/media/adding-machine.e971419c.jpg";